import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
export var Component = /*#__PURE__*/function () {
  function Component(_ref) {
    var componentId = _ref.componentId,
      fields = _ref.fields;
    _classCallCheck(this, Component);
    this.componentId = componentId;
    this.fields = fields;
  }
  _createClass(Component, [{
    key: "getId",
    value: function getId() {
      return this.componentId;
    }
  }, {
    key: "getFields",
    value: function getFields(filter) {
      return this.fields.filter(filter);
    }
  }]);
  return Component;
}();